import { WorkSheet } from 'xlsx'

export { type WorkBook } from 'xlsx'

export async function readSpreadsheet(fileBuffer: ArrayBuffer) {
  const xlsx = await import('xlsx')
  return xlsx.read(fileBuffer)
}

export async function sheetToJson(worksheet: WorkSheet) {
  const xlsx = await import('xlsx')
  return xlsx.utils.sheet_to_json(worksheet) as Record<string, string>[]
}
